// eslint-disable-next-line import/prefer-default-export
export const setBackgroundColor = (colorStr) => {
  try {
    if (typeof (document) !== 'undefined') document.body.style.backgroundColor = colorStr;
  } catch (ex) {
    // do nothing, we just prevent the stupid document is undefined errors to be thrown during server side rendering
  }
};
